import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useTranslation } from "@i18n";
import { api__getOrderTrackingList } from "@/apis/orderTracking/api__getOrderTrackingList";
import { getLocalizedDate } from "@/utils/common";
import SingleOrderComponent from "@/pages/tracking/components/SharedComponents/SingleOrderComponent/SingleOrderComponent";
import Loader from "@componentsShared/Loader/Loader";
import TrackingNoResult from "@/pages/tracking/components/TrackingCheckoutComponents/components/TrackingNoResult/TrackingNoResult";
import DeskTopBlueMobileWhiteHeader from "@/components/sharedComponents/DeskTopBlueMobileWhiteHeader/DeskTopBlueMobileWhiteHeader";
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "./TrackingLanding.module.css";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import useApi from "@hooks/useApi";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var createDetailsPageUrl = function createDetailsPageUrl(order) {
  var url = order.is_finance ? "/tracking-finance-details/" : "/tracking-checkout-details/";
  return url + order.id;
};
var TrackingLandingNew = function TrackingLandingNew() {
  var _useTranslation = useTranslation(["web_tracking_finance", "web_checkout_finance", "web_tracking"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    createUrl = _useHelpers.createUrl;
  var lang = useLang();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useApi = useApi([], function () {
      return api__getOrderTrackingList().then(function (orderOrOrders) {
        if (Array.isArray(orderOrOrders)) {
          return orderOrOrders;
        }
        return navigateTo(createDetailsPageUrl(orderOrOrders));
      });
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    data = _useApi2[2];
  useEffect(function () {
    if (!__IS_CSR__) return;
    var isDirectLink = !document.referrer || !document.referrer.includes(window.location.hostname);
    if (isDirectLink) {
      trackEvents("order_tracking_entry", {
        referral_location: "direct_link",
        platform: getPlatformInfo()
      });
    }
  }, []);
  useEffect(function () {
    if (loading || !data || !Array.isArray(data)) return;
    trackEvents("order_tracking_landing", {
      number_of_orders: data.length,
      platform: getPlatformInfo()
    });
  }, [loading, data]);
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  var oreders = data;
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    mobileHasTitle: t("track_orders", {
      ns: "web_tracking_finance"
    }),
    hideOrangeHeadBtn: true,
    mobileHasBack: true,
    mobileNoLogo: true,
    headHideLinks: true,
    hideFooter: true,
    hideHeaderOnmobile: true
  }, /*#__PURE__*/React.createElement(DeskTopBlueMobileWhiteHeader, {
    title: t("track_car_order", {
      ns: "web_tracking_finance"
    }),
    onClick: function onClick() {
      return navigateTo("/user/account");
    },
    hasDeskTopBack: true
  }), (oreders === null || oreders === void 0 ? void 0 : oreders.length) === 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TrackingNoResult, null)) : (oreders === null || oreders === void 0 ? void 0 : oreders.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.cardsContainerCF
  }, oreders === null || oreders === void 0 ? void 0 : oreders.map(function (order, idx) {
    var localizedDate = getLocalizedDate(new Date(order.order_date), lang, false, "");
    return /*#__PURE__*/React.createElement(SingleOrderComponent, {
      key: idx,
      title: order.post_title,
      image: order.post_image,
      status: order.status,
      color: order.color,
      date: localizedDate,
      link: createUrl(createDetailsPageUrl(order)),
      tag: order.order_title ? {
        txt: order.order_title,
        color: order.title_color
      } : null
    });
  })) : /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true
  }));
};
export default TrackingLandingNew;